import React from 'react';
import PropTypes from 'prop-types';
// import { formatNumber } from 'helper';
import ReactApexCharts from 'react-apexcharts';

function BarChart({
  data,
  valueKey,
  horizontal,
  isLoading,
  seriesName,
  chartOptions,
}) {
  const defaultOptions = {
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: (data || []).map((item, i) => item?.label || `Data ${i + 1}`),
    },
    yaxis: {
      tickAmount: 5,
      min: 0,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal,
      },
    },
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: true,
    },
    colors: ['#977ed1'],
  };

  const series = [
    {
      name: seriesName,
      data: (data || []).map((item) => item[valueKey] ?? null),
    },
  ];
  if (isLoading) {
    if (!horizontal) {
      return (
        <div className="h-full w-full flex items-end space-x-3 p-4">
          <div className="animate-pulse bg-gray-200 h-full w-full rounded" />
          <div className="animate-pulse bg-gray-200 h-5/6 w-full rounded" />
          <div className="animate-pulse bg-gray-200 h-3/6 w-full rounded" />
          <div className="animate-pulse bg-gray-200 h-2/5 w-full rounded" />
          <div className="animate-pulse bg-gray-200 h-1/6 w-full rounded" />
        </div>
      );
    }
    return (
      <div className="space-y-3 p-4">
        <div className="animate-pulse bg-gray-200 h-10 w-full rounded" />
        <div className="animate-pulse bg-gray-200 h-10 w-5/6 rounded" />
        <div className="animate-pulse bg-gray-200 h-10 w-3/6 rounded" />
        <div className="animate-pulse bg-gray-200 h-10 w-2/5 rounded" />
        <div className="animate-pulse bg-gray-200 h-10 w-1/6 rounded" />
      </div>
    );
  }
  return (
    <ReactApexCharts
      height="100%"
      options={{ ...defaultOptions, ...chartOptions }}
      series={series}
      type="bar"
    />
  );
}
BarChart.defaultProps = {
  valueKey: 'count',
  data: {
    labels: [],
    series: [],
  },
  horizontal: true,
  isLoading: false,
  seriesName: 'Count',
  chartOptions: {},
};

BarChart.propTypes = {
  data: PropTypes.instanceOf(Object),
  valueKey: PropTypes.string,
  horizontal: PropTypes.bool,
  isLoading: PropTypes.bool,
  seriesName: PropTypes.string,
  chartOptions: PropTypes.instanceOf(Object),
};

export default BarChart;
